import * as types from '../../constants/log/nftRepairLogConstants'

export const nftRepairLogListRequest = ({
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  nftUid,
  transactionNo,
  callback,
  error,
}) => ({
  type: types.NFT_REPAIR_LOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  nftUid,
  transactionNo,
  callback,
  error,
});
